export type ModelHeaderContext = {
  useDotSeparator: boolean;
  useDinConvention: boolean;
};

/** Minimal model data also supported by immutable document snapshots. */
export type ModelHeaderSource = {
  tag?: string;
  fullTag?: string;
  name?: string;
  nameOfDefaultName?: string;
};

/** Uses the qualified reference designation for DIN and the local tag otherwise. */
export function modelHeaderTag(object: ModelHeaderSource, context: ModelHeaderContext): string {
  return ((context.useDinConvention ? object.fullTag ?? object.tag : object.tag ?? object.fullTag) ?? "").trim();
}

/** Formats model headings consistently, including default names and missing tags. */
export function modelHeaderText(object: ModelHeaderSource, context: ModelHeaderContext): string {
  const tag = modelHeaderTag(object, context);
  const name = (object.nameOfDefaultName ?? object.name ?? "").trim();
  return [tag, name].filter(Boolean).join(context.useDotSeparator ? " · " : " ");
}
